import type { GnbResponse } from '~/types/display/gnb-type'
import { useShopMarketingPopupTransform } from '~/transforms/display/shop-marketing-popup-transform'
import type { PopupInfo } from '~/types/display/popup'
import ShopDisplayEnum from '~/enums/shop-display-enum'
import { useShopGnbTransform } from '~/transforms/display/shop-gnb-response-transform'
import type { IconInfo } from '~/types/display/common'

export function useDisplayService() {
  const { $apiShop } = useNuxtApp()
  const { convertResponse } = useShopGnbTransform()

  // GNB List 조회
  const getGnbList = {
    request: () =>
      $apiShop<GnbResponse>('/display/v1/shop/gnbList', {
        method: 'GET',
      }),
    options: {
      // 데이터가 null 이 아닌 경우 캐시 설정
      transform: convertResponse,
      server: false,
    },
  }
  const { convertPopup } = useShopMarketingPopupTransform()
  const { isApp } = useDevice()
  const dispMediaCd = isApp ? '' : getMediaTypeCode(ShopDisplayEnum.DP015)
  const getMarketingPopupList = {
    request: (popupTgtScrnCd: string, prtTypCd = '') =>
      $apiShop<PopupInfo[]>(`/display/v1/site/popupList?dispMediaCd=${dispMediaCd}&popupTgtScrnCd=${popupTgtScrnCd}&prtTypCd=${prtTypCd}`, {
        method: 'GET',
        parseResponse: data => convertPopup(JSON.parse(data)),
      }),
  }

  const getShortUrl = {
    request: (url: string) =>
      $apiShop<string>(`/common/v1/eai/shortUrl/callShortUrl?orgUrl=${url}`, {
        method: 'GET',
        parseResponse: data => JSON.parse(data).payload,
      }),
  }

  const findIconByCommonCode = {
    request: (codes: string[]) =>
      $apiShop<IconInfo[]>(`/display/v1/icon/findIconByCommonCode`, {
        method: 'GET',
        query: { codes },
      }),
  }

  return {
    getGnbList,
    getMarketingPopupList,
    getShortUrl,
    findIconByCommonCode,
  }
}
